import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useGate, useUnit } from 'effector-react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  type ButtonProps,
} from '@mui/material';
import { Control } from '@unicorn/control';
import { form, Gate, type ConfirmHandler } from './model';

export type Props = {
  title?: string;
  isOpen: boolean;
  onConfirm: ConfirmHandler;
  onClose: NonNullable<ButtonProps['onClick']>;
};

export const SendEmailDialog: FC<Props> = ({ title, isOpen, onConfirm, onClose }) => {
  const { t } = useTranslation();
  const { submittable, submit } = useUnit(form);
  useGate(Gate, { isOpen, onConfirm });

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs">
      <DialogTitle>{title || t('SendingByMail')}</DialogTitle>
      <DialogContent>
        <Control.Text
          label={t('PleaseEnterYourEmailAddress')}
          name="email"
          form={form}
          type="email"
          required
        />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" disabled={!submittable} onClick={submit}>
          {t('Confirm')}
        </Button>
        <Button variant="outlined" onClick={onClose}>
          {t('cancel')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
